import * as React from 'react';
import {connect} from "react-redux";
import {iState, SET_LEFT_YEAR, SET_RIGHT_YEAR, iSetYear} from "./store";
import {YEAR_COUNT} from "./constants";


interface iSetPosition {
    left: string;
    top: string;
}


class YearSelect extends React.Component<{ year: number, pos: iSetPosition, setYear: (y: number) => any}, {}>{

    render(){

        let style = {
            position: 'relative' as 'relative',
            display: 'block',
            padding: '4px',
            backgroundColor: 'white',
            zIndex: 20,
            width: '53px',
            borderRadius: '4px',
            cursor: 'default'

        };

        style['left'] = this.props.pos.left;
        style['top'] = this.props.pos.top;

        let optionArr = [];

        for (let i = 0; i < YEAR_COUNT; i++){
            optionArr.push(<option key={(2017 + i).toString() + 'y'}>{2017 + i}</option>)
        }




        return <div style={style}>
            <select value={this.props.year} onChange={(e) => {
                this.props.setYear(parseInt(e.target.value));
            }
            } >
                {optionArr}
                {/*<option>2017</option>*/}
                {/*<option>2018</option>*/}
                {/*<option>2019</option>*/}
                {/*<option>2020</option>*/}
                {/*<option>2021</option>*/}
            </select>
        </div>
    }
}



export const LeftSelect = connect((s: iState) => {
    return {
        pos: {left: '-73px', top: '11px'},
        year: s.leftYear
    }
}, (dispatch) => {
    return {
        setYear: (n: number) => {
            dispatch({type: SET_LEFT_YEAR, year: n} as iSetYear);
        }
    }
})(YearSelect);


export const RightSelect = connect((s: iState) => {
    return {
        pos: {left: '22px', top: '-15px'},
        year: s.rightYear
    }
}, (dispatch) => {
    return {
        setYear: (n: number) => {
            dispatch({type: SET_RIGHT_YEAR, year: n} as iSetYear);
        }
    }
})(YearSelect);
